import { render, staticRenderFns } from "./jrmf-red-packet.vue?vue&type=template&id=711d7848&"
import script from "./jrmf-red-packet.js?vue&type=script&lang=js&"
export * from "./jrmf-red-packet.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports